import React from "react";
import styles from "./vpn-card.module.scss";
import AndroidIcon from "../../assets/icons/android-icon.png";
import IOSIcon from "../../assets/icons/apple-icon.png";
import FolderIcon from "../../assets/icons/folder-icon.png";
import WindowsIcon from "../../assets/icons/windows-icon.svg";
import LinuxIcon from "../../assets/icons/linux-icon.svg";

import V2RayIcon from "../../assets/icons/v2ray-icon.png";
import WireguardIcon from "../../assets/icons/wireguard-icon.png";

import Card from ".";
import Button, { BTN_VARIANTS } from "../Button";

const DownloadButtons = ({ details }) => {
  return (
    <section className={styles["download-app"]}>
      <span className={styles["download-app-title"]}>Download Now</span>
      <section className={styles["download-app-btns"]}>
        {details.android && (
          <Button className={styles["download-app-btn"]} variant={BTN_VARIANTS.transparent} onClick={() => window.open(details.android)}>
            <img src={AndroidIcon} alt="" />
            <span>Android</span>
          </Button>
        )}
        {details.ios && (
          <Button className={styles["download-app-btn"]} variant={BTN_VARIANTS.transparent} onClick={() => window.open(details.ios)}>
            <img src={IOSIcon} alt="" />
            <span>iOS</span>
          </Button>
        )}

        {details.folder && (
          <Button className={styles["download-app-btn"]} variant={BTN_VARIANTS.transparent} onClick={() => window.open(details.folder)}>
            <img src={FolderIcon} alt="" />
            <span>APK</span>
          </Button>
        )}
        {details.mac && (
          <Button className={styles["download-app-btn"]} variant={BTN_VARIANTS.transparent} onClick={() => window.open(details.mac)}>
            <img src={IOSIcon} alt="" />
            <span>macOS</span>
          </Button>
        )}
        {details.windows && (
          <Button className={styles["download-app-btn"]} variant={BTN_VARIANTS.transparent} onClick={() => window.open(details.windows)}>
            <img src={WindowsIcon} alt="" />
            <span>Windows</span>
          </Button>
        )}
        {details.linux && (
          <Button className={styles["download-app-btn"]} variant={BTN_VARIANTS.transparent} onClick={() => window.open(details.linux)}>
            <img src={LinuxIcon} alt="" />
            <span>Linux</span>
          </Button>
        )}
      </section>
    </section>
  );
};

const PoweredBy = ({ isV2App = false }) => {
  return (
    <section className={styles["powered-by"]}>
      <span className={styles["powered-by-title"]}>Powered by</span>
      <section className={styles["powered-by-powers"]}>
        <section className={`${styles["powered-by-power"]}`}>
          <img src={V2RayIcon} alt="" />
          <span>V2Ray</span>
        </section>
        {!isV2App && (
          <section className={`${styles["powered-by-power"]} ${styles["show-linebetween"]}`}>
            <img src={WireguardIcon} alt="" />
            <span>Wireguard</span>
          </section>
        )}
      </section>
    </section>
  );
};

const VPNCard = ({ title, subtitle, img, details = {}, isV2App = false }) => {
  const [preloaded, setPreloaded] = React.useState(0);
  const [isPreLoaded, setIsPreLoaded] = React.useState(false);

  React.useEffect(() => {
    const preloadThese = [img];
    if (preloaded !== preloadThese.length) {
      preloadThese.forEach((i) => {
        const img = new Image();
        img.src = i;
        img.onload = () => {
          setPreloaded(preloaded + 1);
        };

        img.onerror = () => {
          setPreloaded(preloaded + 1);
        };
      });
    } else {
      setIsPreLoaded(true);
    }
  }, [img, preloaded]);
  return (
    <>
      <Card className={styles.root}>
        <section className={styles.up}>
          <section className={styles["title-section"]}>
            <span className={styles.title}>{title}</span>
            <span className={styles.subtitle}>{subtitle}</span>
          </section>
          {isPreLoaded && <img className={styles["vpn-mobile-img"]} src={img} alt="" />}
        </section>
        <section className={styles.bottom}>
          {details && Object.keys(details).length > 0 ? (
            <>
              <img src={details.icon} alt="" />
              <DownloadButtons details={details} />
              <PoweredBy isV2App={isV2App} />
            </>
          ) : (
            <span className={styles["coming-soon"]}>Coming Soon</span>
          )}
        </section>
      </Card>
    </>
  );
};

export default VPNCard;
